<template>
  <div>
    <h6 style="color: #101010">
      {{ $l('form_header_user') || '成员信息' }}
    </h6>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="d-flex">
        <div class="d-flex" style="margin-right: 10px;">
          <el-avatar shape="square" :src="formData.memImgUrl" :size="64">
            <span style="font-size: 30px;">U</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_userName') || '团队成员'"
              prop="userCode"
            >
              <dict-select
                v-model="formData.userCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_user') || '请选择团队成员'"
                clearable
                filterable
                @change="userChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_userPost') || '职务'">
              <el-input v-model="formData.userPost" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_mobileNumber') || '联系电话'">
              <el-input v-model="formData.mobileNumber" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item :label="$l('form_label_emailAddress') || '邮件地址'">
            <el-input v-model="formData.emailAddress" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_fixedTelephone') || '固定电话'">
            <el-input v-model="formData.fixedTelephone" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_orgName') || '所属公司'">
            <el-input v-model="formData.orgName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_depFullName') || '所属部门'">
            <el-input v-model="formData.depFullName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="mt-3 mb-2 d-flex align-items-center">
      <h6 style="color: #101010" class="m-0">
        {{ $l('form_header_customer') || '负责客户' }}
      </h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addCustomer">
        {{ $l('btn_addCustomer') || '新增客户' }}
      </b-button>
    </div>
    <el-form
      ref="customer"
      class="customer-form"
      v-for="(customer, index) in listCustomer"
      :key="index"
      :model="customer"
      :rules="customerRules"
      size="small"
    >
      <div class="d-flex">
        <div class="d-flex" style="margin-right: 10px;">
          <el-avatar shape="square" :src="customer.bigImageUrl" :size="64">
            <span style="font-size: 20px;">LOGO</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="16">
            <el-form-item
              :label="$l('form_label_custName') || '客户公司名称'"
              prop="custCode"
            >
              <dict-select
                v-model="customer.custCode"
                :selectedLabel.sync="customer.custName"
                url="/master/common/dict/customerSelectByStatus"
                :body="{ dictType: ['W', 'B', 'P', 'Y'] }"
                :placeholder="$l('form_placeholder_cust') || '请选择客户'"
                filterable
                clearable
                style="width: 100%"
                @change="custChange(customer)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_custShortName') || '客户简称'">
              <el-input v-model="customer.custShortName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="d-flex">
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_bizTeamRoles') || '业务团队角色'"
              prop="bizTeamRoles"
            >
              <dict-select
                v-model="customer.bizTeamRoles"
                :placeholder="
                  $l('form_placeholder_bizTeamRoles') || '请选择业务团队角色'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'bizTeamRoles' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item :label="$l('form_label_custCategory') || '负责品类'">
              <dict-select
                v-model="customer.custCategoryCodeList"
                url="/digitalCenter/master/customer/category/select"
                :body="{ custCode: customer.custCode || 'xxx' }"
                :placeholder="
                  $l('form_placeholder_custCategory') || '请选择负责品类'
                "
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="pl-2" v-if="canDelete">
          <el-form-item>
            <template #label>
              <div><br /></div>
            </template>
            <el-tooltip
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="top"
            >
              <i
                class="el-icon-delete text-danger tool-btn"
                @click="deleteCustomer(index)"
              />
            </el-tooltip>
          </el-form-item>
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_userResponsibilities') || '业务职责说明'"
          >
            <el-input
              v-model="customer.userResponsibilities"
              :placeholder="
                $l('form_placeholder_userResponsibilities') ||
                  '请输入业务职责说明'
              "
              type="textarea"
              maxlength="200"
              :rows="4"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ this.$l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ this.$l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
const initCustomer = {
  bigImageUrl: '',
  custCode: '',
  custName: '',
  custShortName: '',
  bizTeamRoles: '',
  userResponsibilities: '',
  custCategoryCodeList: [],
}
export default {
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {
        userPost: '',
        mobileNumber: '',
        emailAddress: '',
        fixedTelephone: '',
        orgName: '',
        depFullName: '',
        memImgUrl: '',
      },
      rules: {
        userCode: [
          {
            required: true,
            message: this.$l('form_placeholder_user') || '请选择团队成员',
            trigger: 'change',
          },
        ],
      },
      customerRules: {
        custCode: [
          {
            required: true,
            message: this.$l('form_placeholder_cust') || '请选择客户',
            trigger: 'change',
          },
        ],
        bizTeamRoles: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bizTeamRoles') || '请选择业务团队角色',
            trigger: 'change',
          },
        ],
      },
      listCustomer: [{ ...initCustomer }],
    }
  },
  computed: {
    canDelete() {
      return this.listCustomer.length > 1
    },
  },
  methods: {
    async userChange(userCode) {
      const getUserInfo = async () => {
        if (!userCode) return {}
        const res = await request({
          url: '/sys/user/detail',
          method: 'POST',
          data: { userCode },
        }).catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getUserInfo()
      this.formData.userPost = data.userPost
      this.formData.mobileNumber = data.mobileNumber
      this.formData.emailAddress = data.emailAddress
      this.formData.fixedTelephone = data.fixedTelephone
      this.formData.orgName = data.orgName
      this.formData.depFullName = data.depFullName
      this.formData.memImgUrl = data.memImgUrl
    },
    async custChange(customer) {
      const { custCode } = customer
      if (!custCode) return

      const getCustomerInfo = async () => {
        if (!custCode) return {}
        const res = await this.$api
          .masterCustomerV2DetailApi({ custCode })
          .catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getCustomerInfo()
      customer.bigImageUrl = data.bigImageUrl
      customer.custShortName = data.custShortName
      customer.custCategoryCodeList = []
    },
    addCustomer() {
      this.listCustomer.unshift({ ...initCustomer })
    },
    async deleteCustomer(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listCustomer.splice(index, 1)
    },
    async validate() {
      const empty = !this.listCustomer?.length
      if (empty) {
        this.$message({
          message:
            this.$l('tips_warning_listCustomer_empty') || '请选择负责客户',
          type: 'warning',
        })
      }

      const result = await validate.formValidate([
        this.$refs.form,
        ...this.$refs['customer'],
      ])
      return result && !empty
    },
    async save() {
      const result = await this.validate()
      if (!result) return (this.backDialogVisible = false)

      const params = {
        ...this.formData,
        listCustomer: this.listCustomer,
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBizTeamSetAddCustomerApi(params)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.customer-form {
  background-color: #f4f6f9;
  padding: 16px;
  padding-bottom: 6px;
  border-radius: 5px;
  margin-bottom: 16px;
  .tool-btn {
    font-size: 22px;
  }
}
</style>
